import { lazy } from 'react';

export const ProductSelectionAutoSettingsPage = lazy(
  () =>
    import(
      /* webpackChunkName: "ProductSelectionAutoSettingsPage" */
      './ProductSelectionAutoSettingsPage'
    ),
);
